import { BaseLayout } from '@app/components/common/BaseLayout/BaseLayout';
import { LAYOUT } from '@app/styles/themes/constants';
import { media } from '@app/styles/themes/constants';
import styled, { css } from 'styled-components';

interface Header {
  $isTwoColumnsLayoutHeader: boolean;
}

export const Header = styled(BaseLayout.Header)<Header>`
  line-height: 1.5;
  background: white;
  border-bottom: 1px solid #ddd;

  padding: ${LAYOUT.mobile.paddingVertical} ${LAYOUT.mobile.paddingHorizontal};
  height: ${LAYOUT.mobile.headerHeight};

  @media only screen and ${media.md} {
    padding: ${LAYOUT.desktop.headerPaddingVertical} ${LAYOUT.desktop.headerPaddingHorizontal};
    height: ${LAYOUT.desktop.headerHeight};

    ${(props) =>
      props?.$isTwoColumnsLayoutHeader &&
      css`
        padding: 0;
      `}
  }
`;
